
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useNavigationUtils } from '@/hooks/useNavigationUtils';

const CTASection = () => {
  const { currentLanguage } = useLanguage();
  const { getContactPath } = useNavigationUtils();

  return (
    <section className="py-24 bg-gradient-to-b from-[#050505] to-[#030303] relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('/images/grid.svg')] bg-center opacity-5"></div>
      
      {/* Purple orb light effect */}
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-800/10 rounded-full blur-[100px]"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center" data-aos="fade-up">
          <h2 className="text-3xl md:text-5xl font-bold font-future text-white mb-6">
            Bereit, Ihre Marketingstrategie mit KI auf das nächste Level zu bringen?
          </h2>
          <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto">
            Nutzen Sie unser Kontaktformular – wir melden uns innerhalb von 24 Stunden und beraten Sie unverbindlich.
          </p>
          
          <Link to={getContactPath()}>
            <Button className="bg-purple-700 hover:bg-purple-600 text-white px-8 py-6 rounded-lg text-lg font-medium transition-all duration-300 shadow-lg shadow-purple-800/30 hover:shadow-purple-700/40 hover:scale-105 group relative overflow-hidden">
              <span className="z-10 relative flex items-center">
                Kontakt
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </span>
              <span className="absolute inset-0 bg-gradient-to-r from-purple-600 to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
            </Button>
          </Link>
        </div>
      </div>
      
      {/* Sticky Mobile CTA */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-[#111111]/90 backdrop-blur-md border-t border-purple-900/20 p-4 z-50">
        <Link to={getContactPath()} className="block w-full">
          <Button className="w-full bg-purple-700 hover:bg-purple-600 text-white py-3 rounded-lg font-medium">
            Kontakt
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default CTASection;
